import { ApiService } from "./api.service";
import { PrimeIcons } from "@primevue/core/api";
import moment from "moment";
import { getMyGemService } from "@/services";
import { Money } from "../helpers/money";
import store from "../store";
import { DOMAIN } from "./domain-constant";
import { AppIcons } from "../constants/app-icons";
import { Core } from "../helpers/core";

export default class CheckService extends ApiService {
  namespace = "check";
  template = "defaultTemplate";
  fullWindow = false;
  listingRelations = "accountName,entityName";
  // Navigation Filter Key [define it if you are filtering a list by same column]
  navFilterKey = "account_id";
  icon = "SafetyBox";
  DOMAIN = -57;
  data = [];
  favicon = "database";
  name = "Deposits";
  showLeftBar = false;
  singular = this.terminology.check.singular;
  plural = this.terminology.check.plural;
  vowel = this.terminology.check.vowel;
  selection = true;
  layout = 2;
  Width = 1500;
  gemItems = [
    {
      key: "listing",
      label: "All Deposits",
      icon: PrimeIcons.LIST,
    },
    {
      key: "create",
      label: "Record a Deposit",
      icon: PrimeIcons.PLUS,
    },
  ];
  columns = [
    {
      header: this.t("account"),
      icon: AppIcons.BOX_WITH_STAR,
      field: "accountName",
    },
    {
      header: this.t("number"),
      icon: AppIcons.SHRED,
      field: "number",
    },
    {
      header: this.t("entityName"),
      icon: AppIcons.SHRED,
      field: "entityName",
    },
    {
      header: this.t("date"),
      icon: AppIcons.GREEN_CALENDAR,
      field: "date",
      template: (data) => {
        return Core.datey(data.date);
      },
      left: "number",
    },
    {
      header: this.t("amount"),
      icon: AppIcons.MONEY,
      field: "amount",
      template: (data) => {
        return Money.format(data.amount);
      },
      left: "number",
    },
  ];
  lineItems = [
    {
      key: "edit",
      label: "Apply Subtotal",
      icon: PrimeIcons.PENCIL,
    },
    {
      key: "announce",
      label: "Bank Line",

      icon: PrimeIcons.LIST,
    },
    {
      key: "email",
      label: "Discount",
      icon: PrimeIcons.ENVELOPE,
    },
    {
      key: "bookmark",
      label: "Good",
      icon: PrimeIcons.BOOKMARK,
    },
    {
      key: "bookmark",
      label: "Inventory Item",
      icon: PrimeIcons.BOOKMARK,
    },
    {
      key: "bookmark",
      label: "Other Change",
      icon: PrimeIcons.BOOKMARK,
    },
    {
      key: "bookmark",
      label: "Over Payment",
      icon: PrimeIcons.BOOKMARK,
    },
    {
      key: "bookmark",
      label: "Service",
      icon: PrimeIcons.BOOKMARK,
    },
    {
      key: "bookmark",
      label: "Tax",
      icon: PrimeIcons.BOOKMARK,
    },
    {
      separator: true,
    },
    {
      key: "inactive",
      label: "Time & Expenses",
      icon: PrimeIcons.LOCK,
    },
  ];
  moreItems = [
    {
      key: "create",
      label: "Load template",
      icon: AppIcons.FOLDER,
      type: "1",
    },
    {
      key: "create",
      label: "Save and preview",
      icon: AppIcons.PREVIEW,
      type: "2",
    },
    {
      key: "create",
      label: "Save and print",
      icon: AppIcons.PRINTER,
      type: "3",
    },
    {
      key: "create",
      label: "Save and e-mail",
      icon: AppIcons.MAIL,
      type: "4",
    },
    {
      key: "create",
      label: "Manage layout",
      icon: AppIcons.LAYOUT,
      type: "5",
    },
  ];
  navItems = [
    {
      key: "listing",
      label: this.t("viewAllEntities", { entity: this.plural }),
      icon: AppIcons.BULLETS,
    },
    {
      key: "bookmark",
      label: this.t("viewMyBookmarks", { entity: this.singular }),
      icon: AppIcons.BOOKMARK,
    },
    {
      key: "inactive",
      label: this.t("viewInactiveEntity", { entity: this.plural }),
      services: 18,
      icon: AppIcons.DISABLE,
    },
  ];
  listMenuItems = [
    {
      key: "edit",
      label: "editAnEntity",
      icon: AppIcons.EDIT,
    },
    {
      key: "announce",
      label: "announceThisEntity",
      services: -3,
      icon: AppIcons.BULLETS,
    },
    {
      key: "email",
      label: "emailThisEntity",
      icon: AppIcons.MAIL,
    },
    {
      key: "bookmark",
      label: "bookmarkThisEntity",
      icon: AppIcons.BOOKMARK,
    },
    {
      key: "inactive",
      label: "inactiveThisEntity",
      icon: AppIcons.LOCK2,
    },
  ];
  filterItems = [
    { name: "Status", key: "status", value: "2", realm: "2" },
    { name: "Date", key: "date", value: "3", realm: "1" },
    { name: "Due Date", key: "due", value: "4", realm: "0" },
  ];
  gemMenuItems = [
    {
      key: "create",
      label: "Record a Deposit",
      icon: PrimeIcons.LIST,
    },
  ];
  listingFooterControls = [
    {
      key: "cancel",
      label: this.t("cancel"),
      icon: PrimeIcons.PLUS_CIRCLE,
    },
    {
      key: "print",
      label: this.t("Print"),
      icon: PrimeIcons.PLUS_CIRCLE,
      action: (context, data, btn) => {
        if (this.shouldHaveSameBankAcct(data)) {
          btn.label = "Loading...";
          let service = getMyGemService(DOMAIN.PRINT_CHECK);
          let props = {
            item: {
              service: service,
              key: "create",
              label: service.plural,
              icon: service.icon,
              source: "active-dp",
              domain: service.DOMAIN,
              file: true,
              item: data,
            },
          };
          context.emitter.emit("open-gem", props);
        }
      },
    },
  ];

  constructor() {
    super("charges");
  }
  async getListFilter() {
    let serviceId = 58;
    return store
      .dispatch("fetch/refresh", {
        serviceId: serviceId,
        data: { type: 1 },
      })
      .then((res) => {
        return res[serviceId];
      });
  }
  shouldHaveSameBankAcct(checks) {
    let isValid = true;
    let acct = null;
    checks.forEach((check) => {
      if (!acct) {
        acct = check.account_id;
      } else if (acct != check.account_id) {
        isValid = false;
        return false;
      }
    });
    if (!isValid) {
      window.alert("Bank accounts should be same.");
      return false;
    }
    return true;
  }
  getName(serviceId, id) {
    var service = getMyGemService(serviceId);
    return service.retrieve(id).then((d) => {
      return d;
    });
  }
}
